// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + ({"154":"customers","300":"tasks","644":"account","678":"clinics","809":"users","919":"documents","925":"patients","945":"dashboard","973":"printforms"}[chunkId] || chunkId) + ".js";
};